import React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { withInject } from '@piwikpro/platform';

const Billing = withInject({
  Billing: 'MarketingCrate.components.Billing'
})(({ Billing: B }: any) => <B />);

export const Route = createFileRoute('/_secured/administration/account/billing/$page/$limit')({
  component: Billing,
});
